export default function validName(str) {
  return str.length <= 50 && /^[a-zA-Zа-яА-ЯёЁ'][a-zA-Z-а-яА-ЯёЁ' .]+[a-zA-Zа-яА-ЯёЁ']?$/.test(str);
}
